import { library } from '@fortawesome/fontawesome-svg-core';
import { faTh, faUsers, faFolderOpen, faListUl, faQuestionCircle, faChevronDown, faCheck } from '@fortawesome/free-solid-svg-icons';

// Add font awesome icons once and reference them in any component
library.add(faTh, faUsers, faFolderOpen, faListUl, faQuestionCircle, faChevronDown, faCheck);
